import React, { useState } from 'react';
import Button from '../../../../components/common/Button';
import styles from './BulkAddPlayerForm.module.css';

function BulkAddPlayerForm({ onSubmit, onCancel }) {
  const [csvData, setCsvData] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    
    const players = csvData
      .split('\n')
      .filter(line => line.trim())
      .map(line => {
        const [name, phone, level, sex] = line.split(',').map(item => item.trim());
        return {
          name,
          phone,
          level: parseFloat(level),
          sex: sex === '1' ? '남자' : '여자',
          manner: 50,
          playStyle: []
        };
      });

    onSubmit(players);
  };

  return (
    <form onSubmit={handleSubmit} className={styles.form}>
      <div className={styles.description}>
        <p>다음 형식으로 입력해주세요:</p>
        <code>이름,전화번호,레벨,성별(1: 남성, -1: 여성)</code>
        <p>예시:</p>
        <code>홍길동,01012345678,2.9,1</code>
      </div>
      <textarea
        className={styles.textarea}
        value={csvData}
        onChange={(e) => setCsvData(e.target.value)}
        placeholder="여러 명의 참가자 정보를 붙여넣기 해주세요."
        rows={10}
      />
      <div className={styles.buttons}>
        <Button type="submit" variant="primary">일괄 추가</Button>
        <Button type="button" onClick={onCancel}>취소</Button>
      </div>
    </form>
  );
}

export default BulkAddPlayerForm; 